import { render, staticRenderFns } from "./InstitutionalReportLinkForm.vue?vue&type=template&id=4b892231&"
import script from "./InstitutionalReportLinkForm.vue?vue&type=script&lang=js&"
export * from "./InstitutionalReportLinkForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports